document.addEventListener("DOMContentLoaded", () => {
  /* ----------------------------------------
   * Slide Helpers
   * ---------------------------------------- */
  const slideUp = (element, duration = 350) => {
    element.style.height = `${element.offsetHeight}px`;
    element.offsetHeight; // force reflow

    element.style.transition = `height ${duration}ms ease`;
    element.style.overflow = "hidden";
    element.style.height = "0";

    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const slideDown = (element, duration = 350) => {
    element.style.removeProperty("display");

    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";

    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.overflow = "hidden";
    element.offsetHeight;

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = `${height}px`;

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const slideToggle = (element, duration = 350) => {
    const isHidden = window.getComputedStyle(element).display === "none";

    if (isHidden) {
      slideDown(element, duration);
    } else {
      slideUp(element, duration);
    }
  };

  /* ----------------------------------------
   * Accordion
   * ---------------------------------------- */
  document.addEventListener("click", (e) => {
    const heading = e.target.closest(
      ".custom-accordion .accordion__heading"
    );

    if (!heading) return;

    e.preventDefault();

    const item = heading.closest(".accordion-item");
    const container = item.closest(".custom-accordion");
    const content = item.querySelector(".accordion__content");

    if (item.classList.contains("open")) {
      item.classList.remove("open");
      slideUp(content);
    } else {
      container.querySelectorAll(".accordion-item.open").forEach((openItem) => {
        openItem.classList.remove("open");

        const openContent = openItem.querySelector(".accordion__content");
        if (openContent) slideUp(openContent);
      });

      item.classList.add("open");
      if (content) slideDown(content);
    }
  });

  // Show content for initially open items
  document
    .querySelectorAll(".custom-accordion .q-item.open .accordion__content,.custom-accordion .accordion-item.open .accordion__content")
    .forEach((content) => {
      content.style.display = "block";
    });

  /* ----------------------------------------
   * Collection Collapsible
   * ---------------------------------------- */
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(
      ".collection-collapsible_top-heading .collapsible-content__heading"
    );

    if (!trigger) return;

    document
      .querySelectorAll(".custom-accordion .custom_collasp-content")
      .forEach((content) => {
        slideToggle(content);
      });

    document
      .querySelectorAll(".custom-accordion")
      .forEach((accordion) => {
        accordion.classList.toggle("active");
      });
  });

  /* ----------------------------------------
   * Tabs
   * ---------------------------------------- */
  document.querySelectorAll(".multicolumn-with-tabs .tab").forEach((tab) => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      this.classList.add("active");

      this.parentElement
        ?.querySelectorAll(".tab")
        .forEach((sibling) => {
          if (sibling !== this) {
            sibling.classList.remove("active");
          }
        });

      const target = this.getAttribute("data-toggle-target");

      document
        .querySelectorAll(".multicolumn-with-tabs .tab-content")
        .forEach((content) => {
          content.classList.remove("active");
        });

      if (target) {
        document.querySelectorAll(target).forEach((content) => {
          content.classList.add("active");
        });
      }
    });
  });

  /* ----------------------------------------
   * Read More / Read Less
   * ---------------------------------------- */
  document.addEventListener("click", (e) => {
    const readMore = e.target.closest(".readmore");
    const readLess = e.target.closest(".readless");

    if (readMore) {
      e.preventDefault();

      document
        .querySelectorAll(".product-description-short")
        .forEach((el) => (el.style.display = "none"));

      document
        .querySelectorAll(".product-description-full")
        .forEach((el) => (el.style.display = "block"));
    }

    if (readLess) {
      e.preventDefault();

      document
        .querySelectorAll(".product-description-full")
        .forEach((el) => (el.style.display = "none"));

      document
        .querySelectorAll(".product-description-short")
        .forEach((el) => (el.style.display = "block"));
    }
  });

  /* ----------------------------------------
   * Responsive Interactions
   * ---------------------------------------- */
  const handleResponsiveInteractions = () => {
    const width = window.innerWidth;

    // Footer accordion
    document
      .querySelectorAll(".footer-block__heading")
      .forEach((heading) => {
        heading.onclick = null;

        if (width < 750) {
          heading.onclick = () => {
            heading.parentElement?.classList.toggle("open");

            const content = heading.parentElement?.querySelector(
              ".footer-block__details-content"
            );

            if (content) slideToggle(content);
          };
        }
      });

    // Mobile sidebar
    document
      .querySelectorAll(".custom-sidebar__menu-mb-title")
      .forEach((btn) => {
        btn.onclick = null;

        if (width < 990) {
          btn.onclick = () => {
            document
              .querySelectorAll(".custom-sidebar__menu, body")
              .forEach((el) => el.classList.add("open-menu"));
          };
        }
      });

    document
      .querySelectorAll(".custom-sidebar__menu .icon.menu-close")
      .forEach((btn) => {
        btn.onclick = null;

        if (width < 990) {
          btn.onclick = () => {
            document
              .querySelectorAll(".custom-sidebar__menu, body")
              .forEach((el) => el.classList.remove("open-menu"));
          };
        }
      });
  };

  // Outside click for sidebar
  document.addEventListener("click", (e) => {
    if (window.innerWidth >= 990) return;

    const insideMenu = e.target.closest(".custom-sidebar__menu");
    const menuTrigger = e.target.closest(".custom-sidebar__menu-mb-title");

    if (!insideMenu && !menuTrigger) {
      document
        .querySelectorAll(".custom-sidebar__menu, body")
        .forEach((el) => el.classList.remove("open-menu"));
    }
  });

  handleResponsiveInteractions();
  window.addEventListener("resize", handleResponsiveInteractions);
});






















































// $(document).ready(function () {

// $('.custom-accordion .accordion__heading').on('click', function (e) {
//   e.preventDefault();

//   let $item = $(this).closest('.accordion-item');
//   let $container = $item.closest('.custom-accordion');
//   let $content = $item.find('.accordion__content');

//   if ($item.hasClass('open')) {
//     $item.removeClass('open');
//     $content.slideUp(350);
//   } else {
//     $container.find('.accordion-item.open')
//       .removeClass('open')
//       .find('.accordion__content')
//       .slideUp(350);

//     $item.addClass('open');
//     $content.slideDown(350);
//   }
// });

// $(document).ready(function () {
//   $('.custom-accordion .accordion-item').not('.open')
//     .find('.accordion__content')
//     .hide();

//   $('.custom-accordion .accordion-item.open')
//     .find('.accordion__content')
//     .show();
// });



// $(".collection-collapsible_top-heading .collapsible-content__heading").on("click", function () {
//   // Slide toggle content
//   $(".custom-accordion .custom_collasp-content").slideToggle();

//   // Toggle active class
//   $(".custom-accordion").toggleClass("active");
// });











  
//   $(".multicolumn-with-tabs .tab").on("click", function (evt) {
//     evt.preventDefault();
//     $(this).addClass("active");
//     $(this).siblings().removeClass("active");
//     var sel = this.getAttribute("data-toggle-target");
//     $(".multicolumn-with-tabs .tab-content")
//       .removeClass("active")
//       .filter(sel)
//       .addClass("active");
//   });

//   // Show More
//   $(document).on("click", ".readmore", function (e) {
//     e.preventDefault();
//     $(".product-description-short").hide();
//     $(".product-description-full").show();
//   });

//   // Show Less
//   $(document).on("click", ".readless", function (e) {
//     e.preventDefault();
//     $(".product-description-full").hide();
//     $(".product-description-short").show();
//   });



  
//   function handleResponsiveInteractions() {
//   const width = window.outerWidth;

//   // Clear previous bindings to avoid duplication
//   $(".footer-block__heading").off("click");
//   $(".custom-sidebar__menu-mb-title").off("click");
//   $(".custom-sidebar__menu .icon.menu-close").off("click");
//   $(document).off("click.sidebar");

//   // Footer dropdown for mobile < 750px
//   if (width < 750) {
//     $(".footer-block__heading").on("click", function () {
//       $(this).parent().toggleClass("open");
//       $(this).siblings(".footer-block__details-content").slideToggle();
//     });
//   }

//   // Sidebar menu for mobile/tablet < 990px
//   if (width < 990) {
//     $(".custom-sidebar__menu-mb-title").on("click", function () {
//       $(".custom-sidebar__menu, body").addClass("open-menu");
//     });

//     $(".custom-sidebar__menu .icon.menu-close").on("click", function () {
//       $(".custom-sidebar__menu, body").removeClass("open-menu");
//     });

//     // Remove menu when clicking outside
//     $(document).on("click.sidebar", function (e) {
//       if (
//         !$(e.target).closest(".custom-sidebar__menu").length &&
//         !$(e.target).closest(".custom-sidebar__menu-mb-title").length
//       ) {
//         $(".custom-sidebar__menu, body").removeClass("open-menu");
//       }
//     });
//   }
// }

// // Run on page load and resize
// $(document).ready(handleResponsiveInteractions);
// $(window).on("resize", handleResponsiveInteractions);

// });
